import { Component, input, output, computed } from '@angular/core';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

export type ActionModalVariant = 'danger' | 'primary';

@Component({
  selector: 'app-action-modal',
  imports: [TranslatePipe],
  templateUrl: './action-modal.html',
  styleUrl: './action-modal.css',
  standalone: true
})
export class ActionModal {
  trigger = input<boolean>(true);
  title = input<string>('Aannemer verwijderen');
  description = input<string>('Weet je zeker dat je deze aannemer definitief wilt verwijderen? Alle gekoppelde gegevens en gerelateerde informatie gaan permanent verloren. Deze actie kan niet ongedaan worden gemaakt.');
  action_state = input<string>('Verwijderen');

  /**
   * Override the auto-detected variant.
   * When omitted the variant is inferred: 'Verwijderen' → danger, everything else → primary.
   */
  variant = input<ActionModalVariant | null>(null);

  // Output events
  cancel = output<void>();
  confirm = output<void>();

  /** Resolved variant: explicit input wins, otherwise infer from action_state. */
  resolvedVariant = computed<ActionModalVariant>(() =>
    this.variant() ?? (this.action_state() === 'Verwijderen' ? 'danger' : 'primary')
  );

  iconSrc = computed(() => {
    if (this.resolvedVariant() === 'primary') {
      return 'assets/icons/check_primary_mark_icon.svg';
    }
    // danger: trash for delete, fallback to close
    return this.action_state() === 'Verwijderen'
      ? 'assets/icons/trash_red_icon.svg'
      : 'assets/icons/close_red_icon.svg';
  });

  iconBgClass = computed(() =>
    this.resolvedVariant() === 'danger' ? 'bg-light_danger' : 'bg-primary_color_light'
  );

  confirmButtonClass = computed(() =>
    this.resolvedVariant() === 'danger'
      ? 'bg-danger border border-danger'
      : 'bg-primary_color border border-primary_color'
  );

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }
}
